<template>
    <v-form>
        <v-card>
            <v-card-title>
                <span class="headline">Add Test</span>
            </v-card-title>

            <v-card-text>
                <autocomplete v-model="testGroupId" label="Test Group" placeholder="Choose the type of test" item-text="label" item-value="id" :url="'/api/TestGroups/Autocomplete'" :filter="filter" />
                <v-expand-transition>
                    <v-container v-show="hasTestGroup">
                        <autocomplete v-model="testId" label="Test" placeholder="Choose the test you would like performed" item-text="label" item-value="id" :url="'/api/Tests/Autocomplete'" :filter="testFilter" required :key="testKey" />
                    </v-container>
                </v-expand-transition>
                <v-expand-transition>
                    <v-container v-show="hasTest">
                        <autocomplete v-model="labId" label="Lab" placeholder="Choose the lab you would like the test performed at" item-text="label" item-value="id" :url="'/api/Labs/Autocomplete'" :filter="labFilter" required :key="labKey" />
                    </v-container>
                </v-expand-transition>
            </v-card-text>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="quaternary" text @click="$emit('cancel')">Cancel</v-btn>
                <v-btn color="quaternary" text @click="add">Add</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
    export default {
        props: [
            'filter',
        ],

        components: {
            autocomplete: () => import('@/components/Autocomplete')
        },

        data() {
            return {
                testId: null,
                testGroupId: null,
                labId: null,
                testKey: 0,
                labKey: 0
            }
        },

        methods: {
            add() {
                this.$emit('input', { testId: this.testId, labId: this.labId });
            }
        },

        computed: {
            testFilter() {
                return {
                    ...this.filter,
                    testGroupId: this.testGroupId
                }
            },
            labFilter() {
                return {
                    ...this.filter,
                    testId: this.testId
                }
            },
            hasTestGroup() {
                return this.testGroupId !== null && typeof this.testGroupId !== "undefined"
            },
            hasTest() {
                return this.testId !== null && typeof this.testId !== "undefined"
            }
        },

        watch: {
            testGroupId() {
                this.testId = null;
                this.testKey++;
            },
            testId() {
                this.labId = null;
                this.labKey++;
            }
        }
    };
</script>
